import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import styles from './BillingTrend.module.css';

interface BillingTrendProps {
	value: string;
	label: string;
	direction: 'up' | 'down';
}

export const BillingTrend = ({ value, label, direction }: BillingTrendProps) => {
	const colorClass = direction === 'up' ? styles.up : styles.down;
	const Icon = direction === 'up' ? ArrowUpward : ArrowDownward;

	return (
		<div className={styles.trend}>
			<Icon className={`${styles.icon} ${colorClass}`} />
			<span className={`${styles.value} ${colorClass}`}>{value}</span>
			<span className={styles.label}>{label}</span>
		</div>
	);
};
